module.exports = __webpack_public_path__ + "media/mingtian.566b8168.mp3";